"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.getInitialValue = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getInitialValue = exports.getInitialValue = function getInitialValue() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultValueVariables = arguments.length > 1 ? arguments[1] : undefined;
  if (defaultValueVariables && settings.defaultValueVariable) {
    if (!(settings.defaultValueVariable in defaultValueVariables)) {
      console.error("There is no variable \"".concat(settings.defaultValueVariable, "\""));
      return;
    }
    var defaultValue = (0, _get2["default"])(defaultValueVariables, settings.defaultValueVariable);
    if (defaultValue !== true && defaultValue !== false) {
      console.error("The value of \"".concat(settings.defaultValueVariable, "\" variable should be boolean."));
      return;
    }
    return defaultValue;
  }
  return settings.isCheckedByDefault;
};
var validate = exports.validate = function validate(value, settings) {
  var error;
  var isCheckNecessary = settings.isCheckNecessary,
    noCheckMessage = settings.noCheckMessage;
  if (isCheckNecessary && !value) {
    error = noCheckMessage;
  }
  return error;
};